/**
 * moneyFormatter — comment on écrit un montant à une famille.
 *
 * Deux formes, et deux seulement : le prix catalogue en euros entiers (« 119 € ») et le montant
 * facturé, servi par l'API en CENTIMES, avec ses deux décimales (« 59,70 € »). Les deux passent
 * par `Intl.NumberFormat("fr-FR")`, donc même séparateur de milliers et même espace INSÉCABLE
 * avant le symbole — en français, cette espace ne se coupe pas en fin de ligne.
 *
 * Ce que ce module ne fait PAS : décider du libellé quand le montant est absent. « — », « 0 € »
 * ou une chaîne vide, c'est une règle métier, elle reste dans l'adaptateur qui la porte.
 */

/** « 119 € » — un prix catalogue, sans centimes. Une fraction est arrondie à l'euro. */
export function euros(amount: number): string {
    return new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 0,
    }).format(amount)
}

/** « 59,70 € » — un montant reçu en CENTIMES, toujours deux décimales. Absent → « 0,00 € ». */
export function eurosCents(cents: number | null | undefined): string {
    return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format((cents ?? 0) / 100)
}
